let i = null;
class f extends Error {
  constructor(e) {
    super(`Missing field in the configuration: ${e}`), Object.setPrototypeOf(this, f.prototype);
  }
}
const M = () => {
  if (!i.region)
    throw new f("region");
  return i.region.startsWith("http") ? i.region : `https://app.checkout.${i.region}.commercetools.com`;
}, L = () => i, w = (o, e = !1) => (i = {
  ...e ? {} : i,
  ...o,
  browserSdkVersion: "0.17.0"
}, i);
var j = /* @__PURE__ */ ((o) => (o.INFO = "info", o.WARN = "warn", o.ERROR = "error", o))(j || {});
const h = (o) => (e) => {
  if (!o || !e) return !1;
  if (o === "*" || e === o) return !0;
  const t = o.split(":"), n = e.split(":");
  return !n[0] || t[0] !== n[0] ? !1 : h(t.slice(1).join(":"))(n.slice(1).join(":"));
}, I = (o) => (e) => h(o)(e.type), N = (o, e) => o.filter(I(e)), C = () => (window.commercetoolsCheckout = window.commercetoolsCheckout || {}, window.commercetoolsCheckout.listeners = window.commercetoolsCheckout.listeners || {}, window.commercetoolsCheckout.listeners), g = (o, e) => {
  const t = `${o}_${Math.round(Math.random() * 1e15)}`, n = ({ origin: r, data: s }) => {
    if (r !== window.location.origin || s.source !== "commercetoolsCheckout") return;
    const m = s || {};
    h(o)(m.type) && e(m);
  };
  window.addEventListener("message", n);
  const c = C();
  return c[t] = n, t;
}, d = (o) => {
  const e = C();
  e[o] && (window.removeEventListener("message", e[o]), delete e[o]);
}, y = () => (window.commercetoolsCheckout = window.commercetoolsCheckout || {}, window.commercetoolsCheckout.subscriptions = window.commercetoolsCheckout.subscriptions || {}, window.commercetoolsCheckout.subscriptions), a = (o, e) => {
  [
    ["info", "onInfo"],
    ["warn", "onWarn"],
    ["error", "onError"]
  ].forEach((t) => {
    const n = t[0], c = t[1], r = y();
    e && r[c] && (d(r[c]), delete r[c]), typeof o[c] == "function" && (r[c] && d(r[c]), r[c] = g(`${n}:*`, o[c]));
  });
}, p = (o, e) => {
  [
    ["info", "logInfo"],
    ["warn", "logWarn"],
    ["error", "logError"]
  ].forEach((t) => {
    const n = t[0], c = t[1], r = y();
    e && r[c] && (d(r[c]), delete r[c]), o[c] === !0 && (r[c] && d(r[c]), r[c] = g(`${n}:*`, function(s) {
      s.payload !== void 0 ? console[n]("[ctc]", s.code, s.payload, s.correlationId) : console[n]("[ctc]", s.code, s.correlationId);
    }));
  });
}, R = (o) => {
  if (typeof o != "object") throw new Error("Bad config, please review docs");
  typeof o.checkoutConfig == "object" && w(o.checkoutConfig), a(o), p(o);
};
var O = /* @__PURE__ */ ((o) => (o.completeFlow = "complete-flow", o.paymentOnly = "payment-only", o))(O || {});
const b = "commercetools-checkout", _ = "data-ctc";
let l;
const $ = typeof window < "u" ? document.body.style.overflow : "", E = () => {
  const o = document.querySelectorAll(`[${_}]`);
  return o.length > 0 && (o[0] instanceof HTMLDivElement || o[0] instanceof HTMLSpanElement) ? o[0] : null;
}, u = () => {
  if (window.commercetoolsCheckout && window.commercetoolsCheckout.root && window.commercetoolsCheckout.root.unmount)
    window.commercetoolsCheckout.root.unmount();
  else {
    const t = E();
    t && (t.innerHTML = "");
  }
  const e = document.getElementById(b);
  e && (document.body.style.overflow = $, e.remove()), l && window.removeEventListener("message", l);
}, A = (o, e) => {
  l = ({ origin: t, data: n }) => {
    if (t === window.location.origin) {
      if ((n == null ? void 0 : n.code) === "checkout_cancelled" && u(), (n == null ? void 0 : n.code) === "checkout_loaded") {
        const { onError: c, onInfo: r, onWarn: s, logError: m, logInfo: D, logWarn: F, ...v } = Object.assign({}, L());
        window.postMessage(
          {
            code: "init_checkout",
            payload: {
              ...v,
              checkoutMode: o,
              // sdkMethod helps differentiate between `checkout` and `checkoutFlow` calls in the SPA
              // as both send CheckoutMode.completeFlow as checkoutMode value
              sdkMethod: e
            }
          },
          window.location.origin
        );
      }
      (n == null ? void 0 : n.code) === "checkout_completed" && u();
    }
  }, window.commercetoolsCheckout = window.commercetoolsCheckout || {}, window.commercetoolsCheckout.listeners = window.commercetoolsCheckout.listeners || {}, window.commercetoolsCheckout.listeners.root && window.removeEventListener("message", window.commercetoolsCheckout.listeners.root), window.commercetoolsCheckout.listeners.root = l, window.addEventListener("message", l);
}, k = async (o, e) => {
  if (u(), A(o, e), !E()) {
    const t = document.createElement("div");
    t.setAttribute("id", b), document.body.appendChild(t), document.body.style.overflow = "hidden";
  }
  if (typeof window.commercetoolsCheckout == "object" && typeof window.commercetoolsCheckout.render == "function")
    window.commercetoolsCheckout.render();
  else {
    const t = document.createElement("script");
    t.src = `${M()}/main.js`, t.onerror = () => console.log(`[ctc] Error loading checkout script on ${t.src}`), document.head.appendChild(t);
  }
}, W = (o) => {
  w(o), k("complete-flow", "checkout");
}, B = (o) => {
  if (typeof o != "object") throw new Error("Bad config, please review docs");
  w(o, !0), a(o, !0), p(o, !0), k("complete-flow", "checkoutFlow");
}, H = (o) => {
  if (typeof o != "object") throw new Error("Bad config, please review docs");
  w(o, !0), a(o, !0), p(o, !0), k("payment-only", "paymentFlow");
}, P = () => {
  u();
}, S = () => {
  window.postMessage({
    code: "session_refreshed"
    /* SessionRefreshed */
  }, window.location.origin);
}, x = () => {
  window.postMessage({
    code: "reload_payment_methods"
    /* ReloadPaymentMethods */
  }, window.location.origin);
};
export {
  O as CheckoutMode,
  j as Severity,
  A as addMessageEventListener,
  W as checkout,
  B as checkoutFlow,
  P as close,
  k as createModal,
  N as filterMessages,
  a as handleCustomSubscriptions,
  p as handleDefaultSubscriptions,
  R as init,
  I as matches,
  H as paymentFlow,
  x as reloadPaymentMethods,
  S as sessionRefreshed,
  g as subscribe,
  h as typeMatches,
  d as unsubscribe
};
